import React from 'react';

export default function Button({ onClick, disabled, icon, label, labelNoMobile, className, type = 'button', style, iconRight = false }) {
	return <button style={style} disabled={disabled || false} type={type} className={"btn " + (className || '')} onClick={onClick || (() => {})}>
		{icon && !iconRight && <span className={'fa fa-' + icon} />}
		{label && <span className={labelNoMobile ? 'rsp-no-mobile' : ''}>{label}</span>}
		{icon && iconRight && <span className={'fa fa-' + icon} />}
	</button>;
}
